import {httpDelete, httpGet, httpPatch, httpPost} from './http.service';
import {IPresentationLabelPreset} from '../incase-domain/presentationLabelPreset';
import {PlayerLabel} from '../incase-domain/playerLabel';

const BASE_URL = 'editor/presentation-label-preset';

export const fetchLabelPresets = (): Promise<IPresentationLabelPreset[]> => {
    return httpGet(BASE_URL);
};

export const createLabelPreset = (name: string, labels: PlayerLabel[]): Promise<IPresentationLabelPreset> => {
    return httpPost(BASE_URL, {name, labels});
};

export const updateLabelPreset = (
    id: string,
    data: Partial<Pick<IPresentationLabelPreset, 'name' | 'labels'>>
): Promise<IPresentationLabelPreset> => {
    return httpPatch(`${BASE_URL}/${id}`, data);
};

export const deleteLabelPreset = (id: string): Promise<boolean> => {
    return httpDelete(`${BASE_URL}/${id}`, {});
};
